import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';
import store from '@/store.js';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        // component: Home
    },
    {
        path: '/docs',
        name: 'docs',
        component: () => import('@/views/Docs.vue'),
        meta: { authRequired: true }
    },
    {
        path: '/qst',
        name: 'qst',
        component: () => import('@/views/Qst.vue'),
    },
    {
        path: '/qst*',
        name: 'qst-catchall',
        component: () => import('@/views/Qst.vue'),
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('./views/About.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('./views/Contact.vue')
    },
    {
        path: '/download',
        name: 'download',
        component: () => import('./views/Download.vue')
    },

    {
        path: '/products',
        name: 'products',
        component: () => import('@/views/Products.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login.vue')
    },
    {
        path: '/pazarsanati',
        name: 'pazarsanati',
        component: () => import('@/views/PazarSanati.vue')
    },
    {
        path: '/pazarsherkati',
        name: 'pazarsherkati',
        component: () => import('@/views/PazarSherkati.vue')
    },
    {
        path: '/pazarasnaf',
        name: 'pazarasnaf',
        component: () => import('@/views/PazarAsnaf.vue')
    },
    {
        path: '/pazarforushgahi',
        name: 'pazarforushgahi',
        component: () => import('@/views/PazarForushgahi.vue')
    },
    {
        path: '/PazarStandard',
        name: 'pazarstandard',
        component: () => import('@/views/PazarStandard.vue')
    },
    {
        path: '/modules12',
        name: 'modules12',
        component: () => import('@/views/Modules12.vue')
    },
    {
        path: '/modulesplus',
        name: 'modulesplus',
        component: () => import('@/views/ModulesPlus.vue')
    },
    {
        path: '/pazar12',
        name: 'pazar12',
        component: () => import('@/views/Pazar12.vue')
    },
    {
        path: '/pazarcloud',
        name: 'pazarcloud',
        component: () => import('@/views/PazarCloud.vue')
    },
    {
        path: '/pazarplus',
        name: 'pazarplus',
        component: () => import('@/views/PazarPlus.vue')
    },
    {
        path: '/purchaseform',
        name: 'purchaseform',
        component: () => import('./views/PurchaseForm.vue')
    },
    {
        path: '/supportform',
        name: 'supportform',
        component: () => import('./views/SupportForm.vue')
    },
    {
        path: '/moduls/tolid',
        name: 'ماژول تولید',
        component: () => import('./views/moduls/Tolid.vue')
    },
    {
        path: '/moduls/hoghugh',
        name: 'hoghugh',
        component: () => import('./views/moduls/Hoghugh.vue')
    },
    {
        path: '/moduls/optic',
        name: 'optic',
        component: () => import('./views/moduls/Optic.vue')
    },
    {
        path: '/moduls/shabake',
        name: 'shabake',
        component: () => import('./views/moduls/Shabake.vue')
    },
    {
        path: '/moduls/pakhsh',
        name: 'pakhsh',
        component: () => import('./views/moduls/Pakhsh.vue')
    },
    {
        path: '/moduls/BI',
        name: 'BI',
        component: () => import('./views/moduls/BI.vue')
    },
    {
        path: '/moduls/control',
        name: 'control',
        component: () => import('./views/moduls/Control.vue')
    },
    {
        path: '/moduls/pakhshmuyragi',
        name: 'pakhshmuyragi',
        component: () => import('./views/moduls/PakhshMuyragi.vue')
    },
    {
        path: '/moduls/chandarzi',
        name: 'chandarzi',
        component: () => import('./views/moduls/ChandArzi.vue')
    },
    {
        path: '/moduls/restaurant',
        name: 'restaurant',
        component: () => import('./views/moduls/Restaurant.vue')
    },
    {
        path: '/moduls/campaign',
        name: 'campaign',
        component: () => import('./views/moduls/Campaign.vue')
    },
    {
        path: '/moduls/shobemarkaz',
        name: 'shobemarkaz',
        component: () => import('./views/moduls/Shobe.vue')
    }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

// Route:: get('/{vue_capture?}', function () { return view('home'); }) => where('vue_capture', '[\/\w\.-]*');
router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.authRequired)) {
        // console.info(1, store.state.isAuthenticated)
        await store.dispatch("checkLoged");
        // console.info(2, store.state.isAuthenticated)
        if (!store.state.isAuthenticated) {
            const path = `/login?redirect=${to.path}`
            // console.info(3, path, to)
            next({ path: path })

        } else {
            // console.info(4, to, from)
            next();
        }
    } else {
        // console.info(5)
        next();
    }
});

export default router;